<svg [attr.height]="size" [attr.width]="size" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path
    [attr.fill]="color"
    [attr.stroke]="color"
    d="M7.5 17.3828C7.5 17.3765 7.50325 17.38 7.49219 17.3955C7.47966 17.4131 7.45465 17.4371 7.41699 17.457L7.39062 17.4707L7.38281 17.4756L5.03223 18.8154H5.03125C4.30538 19.2315 3.75676 19.2077 3.4209 19.0127C3.0849 18.8176 2.79006 18.3518 2.79004 17.5098V7.7793C2.79014 7.57412 2.86738 7.30802 3.01758 7.0498C3.16763 6.7919 3.36236 6.5894 3.54785 6.4834H3.54883L7.5 4.2207V17.3828Z"/>
  <path [attr.fill]="color" [attr.stroke]="color" d="M14.5 6.5498V19.7031L10.25 17.6553V4.44531L14.5 6.5498Z"/>
  <path
    [attr.fill]="color"
    [attr.stroke]="color"
    d="M19.2588 5.18359C19.9846 4.76767 20.5333 4.79231 20.8691 4.9873C21.2051 5.18243 21.5 5.64823 21.5 6.49023V16.2197C21.5 16.425 21.4228 16.6918 21.2725 16.9502C21.1225 17.2079 20.9275 17.4096 20.7422 17.5156L20.7412 17.5166L17.25 19.5176V6.33008L19.2578 5.18457L19.2588 5.18359Z"/>
</svg>
